import PropTypes from 'prop-types';
import React, { useState } from 'react';
import SelectedCheckbox from './selected_checkbox';
import HalfSelectedCheckbox from './half_selected_checkbox';
import useSupplierGroup from '../hooks/useSupplierGroup';
import RightIcon from '../../assets/images/right.svg';
import DownIcon from '../../assets/images/down.svg';

// Class to render the SupplierGroup and the selected suppliers.
export default function SupplierGroup(props) {
  const [showSubsidiaries, setShowSubsidiaries] = useState(true);
  const { group, supplierName, handleChange, label, hasInvoices, displayCheckbox = true } = props;
  const { group: groupData } = useSupplierGroup(group.id, hasInvoices);
  const isGroupSelected = group.selected;

  const deselectSubsidiary = supplier => {
    if (group.selected) {
      handleChange('deselect', group);
      const remainingSuppliers = groupData.suppliers.filter(s => s.id !== supplier.id);
      handleChange('bulkSelect', remainingSuppliers);
    } else {
      handleChange('deselect', supplier);
    }
  };

  const toggleChevron = () => setShowSubsidiaries(!showSubsidiaries);
  const chevron = showSubsidiaries ? <DownIcon /> : <RightIcon />;

  const groupCheckbox = isGroupSelected
    ? <SelectedCheckbox
      key={group.name}
      onDeselect={() => handleChange('deselect', group)}
      label={label} />
    : <HalfSelectedCheckbox
      key={group.name}
      onSelect={() => handleChange('select', group)}
      label={label} />;

  const groupNameLabel = (
    <div className='max-w-[240px] overscroll-x-contain overflow-x-auto text-grey-900'>
      {label}
    </div>
  );

  const groupName = displayCheckbox ? groupCheckbox : groupNameLabel
  const subsidiaries = group.selected ? (groupData?.suppliers || []) : group.selectedSuppliers;

  return (
    <>
      <div className='flex'>
        <a href='javascript:void(0)' className='h-[24px] w-[16px] flex items-center justify-start' onClick={toggleChevron}>
          {chevron}
        </a>
        {groupName}
      </div>
      <div className='ml-[35px] py-2 flex flex-col space-y-1'>
        {showSubsidiaries && subsidiaries.map(supplier => (
          <SelectedCheckbox
            key={supplier.name}
            onDeselect={() => deselectSubsidiary(supplier)}
            label={supplierName(supplier, '')}
            labelClasses='!text-grey-900'
          />
        ))}
      </div>
    </>
  );
}

SupplierGroup.defaultProps = {
  hasInvoices: false
};

SupplierGroup.propTypes = {
  displayCheckbox: PropTypes.bool,
  group: PropTypes.object.isRequired,
  supplierName: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.object.isRequired,
  hasInvoices: PropTypes.bool
};
